import { render, staticRenderFns } from "./LocumUpcomingBookings.vue?vue&type=template&id=1a68733b&"
import script from "./LocumUpcomingBookings.vue?vue&type=script&lang=js&"
export * from "./LocumUpcomingBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports